import { render, staticRenderFns } from "./HotUpdateItem.vue?vue&type=template&id=d28625a0"
import script from "./HotUpdateItem.vue?vue&type=script&lang=js"
export * from "./HotUpdateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports